import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { Toaster } from "sonner";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Accounts from "./pages/Accounts";
import Tags from "./pages/Tags";
import PaymentMethods from "./pages/PaymentMethods";
import Transactions from "./pages/Transactions";
import Settings from "./pages/Settings";
import Report from "./pages/Report";
import AssistantRequests from "./pages/AssistantRequests";
import Invoices from "./pages/Invoices";
import VatAccount from "./pages/VatAccount";
import Costs from "./pages/Costs";

function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="h-screen w-screen flex items-center justify-center">Yükleniyor...</div>;
  if (user === false) return <Navigate to="/login" />;
  return children;
}

function App() {
  return (
    <div className="App font-body min-h-screen text-foreground selection:bg-primary selection:text-primary-foreground">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Layout />}>
              <Route index element={<Dashboard />} />
              <Route path="accounts" element={<Accounts />} />
              <Route path="tags" element={<Tags />} />
              <Route path="payment-methods" element={<PaymentMethods />} />
              <Route path="transactions" element={<Transactions />} />
              <Route path="settings" element={<Settings />} />
              <Route path="report" element={<Report />} />
              <Route path="assistant-requests" element={<AssistantRequests />} />
              <Route path="invoices" element={<Invoices />} />
              <Route path="vat-account" element={<VatAccount />} />
              <Route path="costs" element={<Costs />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
